// A filter condition's `queryOperator` joins it to the NEXT condition, but the
// list shows it in front of that next row ("A"/"NEBO" before the condition).
// These helpers keep every operator with the row it is shown on, so a moved or
// removed row takes its operator along and the result is the same list a user
// would build by hand in the new order. The first row never shows an operator:
// a row that becomes first drops its own, and a row that leaves the top gets
// 'and', the default of a newly added row.
//
// Both return a new array of the same filter objects and update their
// `queryOperator` in place, so the rows keep their identity (and their keys).

const DEFAULT_QUERY_OPERATOR = 'and';

const toRows = filters =>
  filters.map((filter, index) => ({
    filter,
    leadingOperator: index > 0 ? filters[index - 1].queryOperator : null,
  }));

const fromRows = rows =>
  rows.map(({ filter }, index) => {
    filter.queryOperator =
      rows[index + 1]?.leadingOperator || DEFAULT_QUERY_OPERATOR;
    return filter;
  });

export const moveCondition = (filters, oldIndex, newIndex) => {
  const rows = toRows(filters);
  const [moved] = rows.splice(oldIndex, 1);
  rows.splice(newIndex, 0, moved);
  return fromRows(rows);
};

export const removeCondition = (filters, index) => {
  const rows = toRows(filters);
  rows.splice(index, 1);
  return fromRows(rows);
};
